import { Button, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FormAutoCompleteSelectDynamic } from '../../components/hook-form/form-autocomplete-select.dynamic.component';
import { unitsApiKeyStore } from '../../api/units-api-key-store';
import { useFormContext } from 'react-hook-form';
import { customersApiKeyStore } from '../../api/customers-api-key-store';
import { officeApiKeyStore } from '../../api/office-api-key-store';
import { projectsApiKeyStore } from '../../api/projects-api-key-store';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { municipalityApiKeyStore } from '../../api/masters/municipality-api-key-store';
import FormDateField, { DateFormat } from '../../components/hook-form/form-date.field.component';
import dayjs from 'dayjs';
import { cocReportApiKeyStore } from '../../api/coc-report-api-key-store';
import { useLoadData } from '../../hooks/useLoadData';
import { ApiResponse } from '../../models/api-response';

const CocFilter = () => {
  const { setValue } = useFormContext();

  const [officeDisabled, setOfficeDisabled] = useState<boolean>(true);
  const [projectDisabled, setProjectDisabled] = useState<boolean>(true);
  const [unitDisabled, setUnitDisabled] = useState<boolean>(true);
  const [disabledToDate, setDisabledToDate] = useState<boolean>(false);
  const [disabledFromData, setDisabledFromDate] = useState<boolean>(false);

  const [customerID, setCustomerID] = useState<any>();
  const [officeID, setOfficeID] = useState<any>();
  const [projectID, setProjectID] = useState<any>();

  const { data: customerData, isLoading: isCustomerLoading } = useLoadData<ApiResponse<any[]>>(
    customersApiKeyStore.getCustomers()
  );
  const { data: officeData, isLoading: isOfficeLoading } = useLoadData<ApiResponse<any[]>>(
    officeApiKeyStore.getCustomerOffices(customerID),
    !!customerID
  );
  const { data: projectData, isLoading: isProjectLoading } = useLoadData<ApiResponse<any[]>>(
    projectsApiKeyStore.getOfficeProjects(officeID),
    !!officeID
  );
  const { data: unitData, isLoading: isUnitLoading } = useLoadData<ApiResponse<any[]>>(
    unitsApiKeyStore.getProjectUnits(projectID),
    !!projectID
  );

  useEffect(() => {
    setValue('fromDate', dayjs().subtract(2, 'week').format(DateFormat.SIMPLE_DATE));
    setValue('toDate', dayjs().format(DateFormat.SIMPLE_DATE));
    setDisabledFromDate(true);
    setDisabledToDate(true);
  }, [setValue]);

  const handleCustomerChange = (value: any) => {
    setCustomerID(value?.customerID);
    setOfficeDisabled(!value);
    setProjectDisabled(true);
    setUnitDisabled(true);
    setValue('office', { officeID: '', officeName: '' });
    setValue('project', { projectID: '', projectName: '' });
    setValue('unit', { unitID: '', unitName: '' });
  };
  const handleOfficeChange = (value: any) => {
    setOfficeID(value?.officeID);
    setProjectDisabled(!value);
    setUnitDisabled(true);
    setValue('project', { projectID: '', projectName: '' });
    setValue('unit', { unitID: '', unitName: '' });
  };
  const handleProjectChange = (value: any) => {
    setProjectID(value?.projectID);
    setUnitDisabled(!value);
    setValue('unit', { unitID: '', unitName: '' });
  };

  const handleFromDate = (date: any) => {
    setDisabledToDate(!!date);
    setValue('toDate', '');
  };

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Grid container spacing={1}>
            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteSelectDynamic
                name="customer"
                label="Customer"
                onChange={handleCustomerChange}
                dataItems={customerData?.data}
                parentLoading={isCustomerLoading}
                optionsValueKey="customerID"
                optionsLabelKey="customerName"
              />
            </Grid>
            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteSelectDynamic
                name="office"
                label="Offices"
                disabled={officeDisabled}
                watchKeys={['customer']}
                onChange={handleOfficeChange}
                dataItems={officeData?.data}
                parentLoading={isOfficeLoading}
                optionsValueKey="officeID"
                optionsLabelKey="officeName"
              />
            </Grid>
            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteSelectDynamic
                name="project"
                label="Projects"
                disabled={projectDisabled}
                watchKeys={['office']}
                onChange={handleProjectChange}
                dataItems={projectData?.data?.filter((project) => project?.coCRequired == true)}
                parentLoading={isProjectLoading}
                optionsValueKey="projectID"
                optionsLabelKey="projectName"
              />
            </Grid>
            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteSelectDynamic
                name="unit"
                label="Lot/Unit"
                disabled={unitDisabled}
                watchKeys={['project']}
                dataItems={unitData?.data}
                parentLoading={isUnitLoading}
                optionsValueKey="unitID"
                optionsLabelKey="unitName"
              />
            </Grid>

            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteSelectDynamic
                name="municipality"
                label="Municipality"
                // disabled={unitDisabled}
                // watchKeys={['project']}
                getQueryKeyConfig={() => municipalityApiKeyStore.getMunicipalities()}
                optionsValueKey="municipalityID"
                optionsLabelKey="muncipalityName"
              />
            </Grid>

            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteSelectDynamic
                name="cocStatus"
                label="Status"
                getQueryKeyConfig={() => cocReportApiKeyStore.getCocReportStatus()}
                optionsValueKey="coCStatusValue"
                optionsLabelKey="coCStatus"
              />
            </Grid>
            {/* <Grid item xl={3} lg={3} sm={4} xs={6}>
              <FormAutoCompleteMultiSelectDynamic
                name="status"
                label="Status"
                // onChange={() => {
                //   hanldeChangeWorkOrderID();
                // }}
                // disabled={!getValues('customer')?.customerID}
                getQueryKeyConfig={() => workOrdersApiKeyStore.getWorkOrderStatuses('inspection')}
                optionsValueKey="workOrderStatusID"
                optionsLabelKey="workOrderStatus"
              />
            </Grid> */}
            <Grid item xl={1.5} lg={1.5} sm={4} xs={6}>
              <FormDateField
                label="Date From"
                name="fromDate"
                onChange={handleFromDate}
                disabled={!disabledFromData}
                format={DateFormat.SIMPLE_DATE}
              />
            </Grid>
            <Grid item xl={1.5} lg={1.5} sm={4} xs={6}>
              <FormDateField
                label="Date To"
                name="toDate"
                disabled={!disabledToDate}
                format={DateFormat.SIMPLE_DATE}
                dateLimits={{
                  minDateEnabled: true,
                  minDateValue: 'fromDate',
                }}
              />
            </Grid>
            {/* <Grid item xl={3} lg={3} sm={4} xs={6}>
              <TextField name="searchKey" label="Search" />
            </Grid> */}

            <Grid item xl={3} lg={3} sm={4} xs={6}>
              <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <Button type="submit" title="Filter" variant="contained" startIcon={<FilterAltOutlinedIcon />}>
                  Filter
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default CocFilter;
